import Button from 'tailwind-components/Button/Button';
import Card from 'components/Card/Card';
import Modal from 'tailwind-components/Modal/Modal';
import ModalActionConfirmation from 'components/ModalActionConfirmation/ModalActionConfirmation';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import SendEmailConfirmationForm from 'components/SendEmailConfirmationForm/SendEmailConfirmationForm';
import bankAccountFactory from 'helpers/factory/bankAccountFactory';
import { getCompany } from 'helpers/getCompanyVariables';
import styles from '../AgencySettings.module.scss';
import { Pencil } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const company = getCompany();

const AgencyBankInformation = ({
  agencyInformation,
  SendEditAgencyInfoFormToAgent,
  focusEditBankingInfo = false
}) => {
  const [isOpenPrimaryModal, setIsOpenPrimaryModal] = useState(false);
  const [isOpenSecondaryModal, setIsOpenSecondaryModal] = useState(false);
  const navigate = useNavigate();
  const editButtonRef = useRef(null);

  useEffect(() => {
    if (focusEditBankingInfo && editButtonRef.current) {
      editButtonRef.current.focus();
      editButtonRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }, [focusEditBankingInfo]);

  let accountNumber = agencyInformation.Agency_Account_Number
    ? bankAccountFactory(agencyInformation.Agency_Account_Number)
    : '---';
  return (
    <>
      <Card
        title='Agency Banking Information'
        titleType='primary'
        options={
          <div ref={editButtonRef}>
            {company === 'oneill' ? (
              <Button
                variant='primary'
                size='medium'
                text='Edit'
                icon={<Pencil size={20} />}
                onClick={() => setIsOpenSecondaryModal(true)}
              />
            ) : (
              <Button
                variant='primary'
                size='medium'
                text='Edit'
                icon={<Pencil size={20} />}
                onClick={() => setIsOpenPrimaryModal(true)}
              />
            )}
          </div>
        }
      >
        <div className={styles.agencyInformation}>
          <div>
            <p>Bank Name</p>
            <span>
              {agencyInformation.Name_of_Financial_Institution
                ? agencyInformation.Name_of_Financial_Institution
                : '---'}
            </span>
          </div>

          <div>
            <p>Routing Number Type</p>
            <span>
              {agencyInformation.Agency_Routing_Number_Type
                ? agencyInformation.Agency_Routing_Number_Type
                : '---'}
            </span>
          </div>
          <div>
            <p>Routing Number</p>
            <span>
              {agencyInformation.Agency_Routing_Number
                ? agencyInformation.Agency_Routing_Number
                : '---'}
            </span>
          </div>
          <div>
            <p>Account Number </p>
            <span>{accountNumber}</span>
          </div>
        </div>
      </Card>
      {company === 'oneill' && (
        <Modal
          size='large'
          title={"You're about to update your Agency Bank Information"}
          active={isOpenSecondaryModal}
          className={styles.modal}
          closeModal={() => setIsOpenSecondaryModal(false)}
        >
          <ModalActionConfirmation
            onCancel={() => setIsOpenSecondaryModal(false)}
            modalText={
              '<p>Want to update your Personal Bank Info instead?</p>' +
              '<ul>' +
              '<li>Go to the My Profile tab <strong>></strong> Personal Bank Info <strong>></strong> Edit</li>' +
              '<li>Or click the button below to be redirected</strong></li>' +
              '</ul>'
            }
            primaryButtonText={'Edit Agency Bank Info'}
            secondaryButtonText={'Go to Personal Bank Info'}
            onPrimaryConfirm={() => setIsOpenPrimaryModal(true)}
            onSecondaryConfirm={() => {
              navigate('/my-profile');
              sessionStorage.setItem('focus_personal_banking_edit', true);
            }}
          />
        </Modal>
      )}
      <Modal
        active={isOpenPrimaryModal}
        className={styles.modal}
        closeModal={() => setIsOpenPrimaryModal(false)}
        title={'Agency Bank Information'}
      >
        <SendEmailConfirmationForm
          closeModal={() => setIsOpenPrimaryModal(false)}
          modalText={
            'We will send you an email with links to securely update your <strong>Agency Bank Information</strong>.<br/><br/>Please click "Send" below.'
          }
          dispatchFunction={SendEditAgencyInfoFormToAgent}
        />
      </Modal>
    </>
  );
};
AgencyBankInformation.propTypes = {
  agencyInformation: PropTypes.object,
  SendEditAgencyInfoFormToAgent: PropTypes.func,
  focusEditBankingInfo: PropTypes.bool
};

export default AgencyBankInformation;
